/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 20:34:02
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:31:35
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';
// 用户菜单列表
export const listMenus = params => {
	return request({
		url: 'api/menu/menu-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 用户权限信息
export const getPermissionInfo = params => {
	return request({
		url: '/api/menu/permission-info',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 查询全部字典数据列表
export const listSimpleDictDatas = params => {
	return request({
		url: '/api/team-manage/dict-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
